import { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../config";
import axios from 'axios';
import { UserContext } from './MyContext';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import TransitEnterexitIcon from '@mui/icons-material/TransitEnterexit';
import { FaUserCog } from "react-icons/fa";
import { FaBars } from 'react-icons/fa';
import { isTokenExpired } from '../js/global';

export default function NewNavbar() {
  const { userData, setUserData } = useContext(UserContext);
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const assetBaseUrl = process.env.PUBLIC_URL;
  const displayName = [userData.firstname, userData.surname].filter(Boolean).join(' ');

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(config.urlApi + '/users/showUserApi', config.headers());

      if (response.status === 200) {
        setUserData({
          firstname: response.data.result.fname,
          surname: response.data.result.sname,
          roleName: response.data.result.role.role_name,
          facultyName: response.data.result.faculty.fac_name,
          campusName: response.data.result.faculty.campus.campus_name,
          facultyID: response.data.result.faculty.id,
          campusID: response.data.result.faculty.campus_id,
          latitude: response.data.result.faculty.latitude,
          longitude: response.data.result.faculty.longitude,
          logo: response.data.result.faculty.logo,
          email: response.data.result.email

        });
      }
    } catch (error) {
      console.error('fetchData error:', error);
      localStorage.removeItem(config.token_name);
      sessionStorage.removeItem(config.token_name);
      navigate('/login');
    }
  }, [navigate, setUserData]);


  useEffect(() => {
    const token = localStorage.getItem(config.token_name) || sessionStorage.getItem(config.token_name);

    if (token) {
      if (isTokenExpired(token)) {
        localStorage.removeItem(config.token_name);
        sessionStorage.removeItem(config.token_name);
        Swal.fire({
          icon: 'warning',
          title: 'Session หมดอายุ',
          text: 'กรุณาเข้าสู่ระบบอีกครั้ง',
        }).then(() => {
          navigate('/login');
        });
      } else {
        if (!userData?.email) {
          fetchData();
        }
      }
    } else {
      navigate('/login');
    }
  }, [fetchData, navigate, userData?.email]);


  const handlerSignOut = (event) => {
    try {
      event.preventDefault();

      Swal.fire({
        icon: 'question',
        title: 'ออกจากระบบ',
        text: 'ต้องการออกจากระบบหรือไม่?',
        showConfirmButton: true,
        showCancelButton: true
      }).then(res => {
        if (res.isConfirmed) {
          localStorage.removeItem(config.token_name);
          sessionStorage.removeItem(config.token_name);

          Swal.fire({
            icon: 'success',
            title: 'ออกจากระบบ',
            text: 'ออกจากระบบเรียบร้อย',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
            timerProgressBar: true,
          });

          navigate('/login');
        }
      })
    } catch (e) {
      console.log(e.message);
    }
  }

  const enterFullScreen = () => {
    document.documentElement.requestFullscreen();
  };

  const exitFullScreen = () => {
    document.exitFullscreen();
  };

  const handleButtonClick = () => {
    if (isFullscreen) {
      fetchData();
      exitFullScreen();
    } else {
      enterFullScreen();
    }
    fetchData();
  };

  useEffect(() => {
    const handleChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);
  const userDefaultImagePath = `${assetBaseUrl}/img/default-user.webp`;

  return (
    <nav className="navbar navbar-expand-lg main-navbar app-topbar">
      <div className="app-topbar-left-group">
        <button
          type="button"
          className="btn btn-link app-topbar-nav-toggle d-inline-flex d-lg-none"
          data-toggle="sidebar"
          aria-label="เปิดเมนู"
        >
          <FaBars />
        </button>
        <div className="app-topbar-intro d-none d-lg-flex">
          <span className="app-topbar-badge">
            <i className="fa-solid fa-sparkles"></i>
            Landscape Workspace
          </span>
          <div className="app-topbar-title-group">
            <strong>Carbon Management Dashboard</strong>
            <span>ติดตามข้อมูลกิจกรรม มาตรการ และเอกสาร</span>
          </div>
        </div>
      </div>
      <ul className="navbar-nav navbar-right">
        <li className="nav-item d-none d-xl-flex align-items-center me-3">
          <div className="app-topbar-context-pill">
            <div>
              <strong>{userData.facultyName || userData.campusName || 'CMU Landscape Net Zero'}</strong>
              <span>{userData.roleName || 'User workspace'}</span>
            </div>
          </div>
        </li>
        <li className="dropdown">
          <button type="button" data-toggle="dropdown" className="nav-link dropdown-toggle nav-link-lg box-user-dropdown app-user-chip btn btn-link">
            <div className="app-user-meta d-none d-lg-flex">
              <span className="app-user-name">{displayName || 'ผู้ใช้งานระบบ'}</span>
              <small>{userData.campusName || userData.roleName || 'Landscape user'}</small>
            </div>
            <span className="app-user-avatar-shell">
              <img src={userData.logo ? `${config.urlApi}/logos/${userData.logo}` : userDefaultImagePath} alt="profile-user" className="img-user" />
            </span>
          </button>
          <div className="dropdown-menu">
            <Link to="/account-setting" className="dropdown-item user-menu">
              <FaUserCog />
              Account Setting
            </Link>

            <button type="button" className="dropdown-item user-menu" onClick={handleButtonClick}>
              {isFullscreen
                ? <><TransitEnterexitIcon />   Contract</>
                : <><AspectRatioIcon />   Expand</>}
            </button>

            <button type="button" onClick={handlerSignOut} className="dropdown-item user-menu">
              <i className="ion-ios-redo"></i> Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>
  )
}